import React, { useEffect, useRef } from "react";
import "./FeatureNoticeModal.css";

/**
 * 새로 생긴 기능을 한 번만 알린다.
 *
 * 본 적이 있으면 다시 뜨지 않는다. 기기마다 한 번씩 뜨는 건 감수한다 —
 * 이것 때문에 서버에 기록을 남길 만한 일이 아니다.
 */
export default function FeatureNoticeModal({ onClose, onGo }) {
  const goRef = useRef(null);

  useEffect(() => {
    goRef.current?.focus();
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="fn-overlay" onClick={onClose}>
      <div
        className="fn-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="fn-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="fn-label">새로 생겼어요</div>

        {/* 기능을 말로만 설명하면 무엇이 나오는지 모른다.
            선 하나를 그려 보여주는 편이 빠르다. */}
        <svg className="fn-art" viewBox="0 0 200 90" aria-hidden="true">
          <rect x="20" y="8" width="160" height="74" fill="none"
                stroke="#f5f0e8" strokeOpacity=".12" strokeWidth="1" />
          <line x1="20" y1="45" x2="180" y2="45" stroke="#f5f0e8" strokeOpacity=".07" />
          <line x1="100" y1="8" x2="100" y2="82" stroke="#f5f0e8" strokeOpacity=".07" />
          <polyline points="42,60 68,26 96,50 122,20 152,64"
                    fill="none" stroke="#c9a84c" strokeWidth="1.6"
                    strokeLinejoin="round" opacity=".85" />
          {[[42,60],[68,26],[96,50],[122,20],[152,64]].map(([x, y]) => (
            <circle key={x} cx={x} cy={y} r="3" fill="#f5f0e8" />
          ))}
        </svg>

        <h2 id="fn-title" className="fn-title">한 해의 독서 궤적을<br />이미지로 내보낼 수 있어요</h2>

        <p className="fn-body">
          읽은 순서대로 감정 좌표를 이으면 선이 됩니다.
          <br />
          <span className="fn-dim">어디서 시작해 어디로 갔는지가 한 장에 남아요.</span>
        </p>

        <button ref={goRef} className="fn-go" onClick={onGo}>내 궤적 보러 가기 →</button>
        <button className="fn-later" onClick={onClose}>나중에</button>
      </div>
    </div>
  );
}
